import GetCalendarFoldersResponse from 'owa-service/lib/contract/GetCalendarFoldersResponse';
import getCalendarFoldersOperation from 'owa-service/lib/operation/getCalendarFoldersOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Makes the call to the server to get all calendar folders and groups configuration
 * @returns promise of GetCalendarFoldersResponse type
 */
export default function loadCalendarFolders(): Promise<GetCalendarFoldersResponse> {
    return getCalendarFoldersOperation({
        Header: getJsonRequestHeader(),
    }).then(response => {
        if (response && response.WasSuccessful) {
            return response;
        } else {
            throw new Error(`getCalendarFoldersOperation ${response.ErrorCode}`);
        }
    });
}
